import { combineReducers } from 'redux'
import authReducer from 'modules/Auth/reducers'
import AppliedRoles from 'modules/Applied_Roles/reducers'
import { onboarding } from 'modules/Onboarding/reducers'
import Roles from 'modules/Roles/reducers'
import ViewRole from 'modules/ViewRole/reducers'
import ManageProfile from 'modules/ManageProfile/reducers'
import Resume from 'modules/Resume/reducers'
import Drive from 'modules/Drives/reducers'
import DriveDetails from 'modules/DriveDetails/reducers'
import OfferLetter from 'modules/OfferLetter/reducers'
import Assessment from 'modules/Assessments/reducers'
export default combineReducers({
  auth: authReducer,
  studentData: onboarding,
  appliedRoleData: AppliedRoles,
  rolesListData: Roles,
  viewRoleDetails: ViewRole,
  userPreferenceData: ManageProfile,
  resumeData: Resume,
  driveData: Drive,
  driveDetails: DriveDetails,
  offerLetterData: OfferLetter,
  assessment: Assessment,
})
